export enum PublicApiAuthScope {
  OrdersRead = "orders_read",
  OrdersWrite = "orders_write",
  CustomersRead = "customers_read",
  CustomersWrite = "customers_write",
  ProductsRead = "products_read",
  ProductsWrite = "products_write",
  ReturnsRead = "returns_read",
  ReturnsWrite = "returns_write",
  WebhooksRead = "webhooks_read",
  WebhooksWrite = "webhooks_write",
  InventoryRead = "inventory_read",
  InboundShipmentsRead = "inbound_shipments_read",
  InvoicesRead = "invoices_read",
  CustomerEventsWrite = "customer_events_write",
  StorefrontEventsWrite = "storefront_events_write",
  LocationsRead = "locations_read",
  LocationsWrite = "locations_write",
}
